var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnergetics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.786,
    height: 21,
    viewBox: "0 0 30.786 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1900",
    "data-name": "Groupe 1900",
    transform: "translate(-1118.145 -444.52)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_719",
    "data-name": "Trac\\xE9 719",
    d: "M1169.145,670.52h10.724l2.062,1.5-2.062,1.5h-10.724Z",
    transform: "translate(-51 -226)",
    fill: "#3c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_720",
    "data-name": "Trac\\xE9 720",
    d: "M1169.145,670.52h13.724l2.062,1.5-2.062,1.5h-13.724Z",
    transform: "translate(-51 -223)",
    fill: "#5cae38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_721",
    "data-name": "Trac\\xE9 721",
    d: "M1169.145,670.52h16.724l2.062,1.5-2.062,1.5h-16.724Z",
    transform: "translate(-51 -220)",
    fill: "#dbd93c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_722",
    "data-name": "Trac\\xE9 722",
    d: "M1169.145,670.52h19.724l2.062,1.5-2.062,1.5h-19.724Z",
    transform: "translate(-51 -217)",
    fill: "#fff43c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_723",
    "data-name": "Trac\\xE9 723",
    d: "M1169.145,670.52h22.724l2.062,1.5-2.062,1.5h-22.724Z",
    transform: "translate(-51 -214)",
    fill: "#fbbe2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_724",
    "data-name": "Trac\\xE9 724",
    d: "M1169.145,670.52h25.724l2.062,1.5-2.062,1.5h-25.724Z",
    transform: "translate(-51 -211)",
    fill: "#eb7230"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_725",
    "data-name": "Trac\\xE9 725",
    d: "M1169.145,670.52h28.724l2.062,1.5-2.062,1.5h-28.724Z",
    transform: "translate(-51 -208)",
    fill: "#e40021"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergetics);
export default __webpack_public_path__ + "static/media/energetics.2dbc5d55.svg";
export { ForwardRef as ReactComponent };